import {observer} from "mobx-react";
import {Action, FieldAutoComplete, FieldSelect, ModalDialog, Page, ScrollTable} from "../../ui";
import {
    DialogStore,
    stsZebraPrinterStore,
    stsDetailStore,
    StsPrinterItem,
    stsCustomerCabinetStore
} from "../../../store";
import {StsDetailPageIntro} from "./StsDetailPageIntro";
import {convertDocumentType} from "../../../api";
import {useState} from "react";
import {DialogAction} from "@kroschke/react-ui";

const StsDetailPage = observer(function StsDetailPage() {
    const {
        vin
    } = stsDetailStore
    const display = `${vin}`
    const [finishDialogStore] = useState(new DialogStore())
    const [labelPrinter, setLabelPrinter] = useState<StsPrinterItem|undefined>()
    const [cabinet, setCabinet] = useState<string | undefined>()

    const dataSetForFinishUpdate = Boolean(cabinet) && Boolean(labelPrinter)

    const actions:Action[] = []
    const dialogActions: DialogAction[] = [
        {
            label: "Abbrechen",
            disabled: stsDetailStore.updating,
            execute: async function () {
                finishDialogStore.dialogOpen = false
            },
            className: 'is-rounded is-small'
        },
        {
            label: 'Abschließen',
            className: 'is-small is-rounded is-primary',
            disabled: !stsDetailStore.printerOrCabinetUpdatable || !dataSetForFinishUpdate,
            executing: stsDetailStore.updating,
            execute: async () => {
                const labelPrinterId = labelPrinter?.id
                const destinationCabinet = cabinet
                if (labelPrinterId && destinationCabinet) {
                    await stsDetailStore.update({
                        labelPrinterId,
                        destinationCabinet
                    })
                    finishDialogStore.dialogOpen = false
                }
            }
        }
    ]

    const customerId = stsDetailStore.data?.customerId

    if (stsDetailStore.printerOrCabinetUpdatable && customerId) {

        actions.push({
            label: 'Vorgang abschließen',
            icon: 'input',
            action: async () => {
                finishDialogStore.dialogOpen = true
                await Promise.all([
                    stsCustomerCabinetStore.load(customerId),
                    stsZebraPrinterStore.load()
                ])
            }
        })
    }


    return <Page
        breadcrumb={[
            {
                link: '/sts',
                label: `Umlagerung`
            },
            {
                link: `/sts/${stsDetailStore.id}`,
                label: display
            }
        ]}
        actions={actions}
        topper={<StsDetailPageIntro />}
    >
        <>
            <ModalDialog
                store={finishDialogStore}
                actions={dialogActions}
                title={"Vorgang abschließen"}
            >
                <div className={'columns'}>
                    <div className={'column is-full'}>
                        <FieldAutoComplete
                            label={"Labeldrucker"}
                            required={true}
                            invalid={!Boolean(labelPrinter)}
                            value={labelPrinter}
                            options={stsZebraPrinterStore.options}
                            itemRenderer={c => c.label}
                            search={stsZebraPrinterStore.search}
                            onChange={(printer: StsPrinterItem | undefined) => setLabelPrinter(printer)}
                        />
                    </div>
                </div>
                <div className={'columns'}>
                    <div className={'column is-full'}>
                        <FieldSelect
                            label={'Schrank'}
                            options={stsCustomerCabinetStore.cabinetsAsOption}
                            value={cabinet}
                            invalid={!Boolean(cabinet)}
                            required={true}
                            onChange={e => setCabinet(e)}
                        />
                    </div>
                </div>
            </ModalDialog>
            <ScrollTable>
                <thead>
                <tr>
                    <th>Typ</th>
                    <th>Dokumente-Id</th>
                    <th>Zusatz</th>
                </tr>
                </thead>
                <tbody>
                {stsDetailStore.listItems.map(item => <tr key={item.documentId}>
                    <td>{convertDocumentType(item.documentType)}</td>
                    <td>{item.documentId}</td>
                    <td>{item.addition}</td>
                </tr>)}
                </tbody>
            </ScrollTable>
        </>
    </Page>
})

export {
    StsDetailPage
}
